import { Controller } from '@hotwired/stimulus'
import { render, renderString } from 'nunjucks'
import GLightbox from 'glightbox'

import { router, Routes, currentMatch } from '../router'

import {
    retrieveSession,
    retrieveTmp,
    sendEvent,
    setHtml,
    subscribeEvent,
    target,
    unsubscribeEvent
} from '../utils'

import { Events } from '../constants'

export default class extends Controller {

    static targets = [
        'visit-details',
    ]

    static values = {
    }

    state = {
        session: null,
        id: null,
        notification: null,
        evidences: []
    }

    instances = {
        lightbox: {
            complaints: null,
            evidences: null
        }
    }

    visitDetails = () => target(this, 'visit-details')

    complaints = () => target(this, 'complaints')

    evidences = () => target(this, 'evidences')

    initialize = () => {

        const { data: { id } } = currentMatch()

        if (! id) {

            router.navigate(Routes[5].url, {
                historyAPIMethod: 'replaceState'
            })

            return
        }

        this.state.id = id
    }

    connect = () => {

        this.refreshOnLogin()

        subscribeEvent(Events.ON_LOGIN, this.refreshOnLogin)
    }

    disconnect = () => {

        unsubscribeEvent(Events.ON_LOGIN, this.refreshOnLogin)
    }

    refreshOnLogin = () => {

        retrieveSession()
            .then((session) => {

                if (! session) {

                    sendEvent(Events.SHOW_LOGIN, { message: '' })

                    return
                }

                this.state.session = session

                return retrieveTmp()
                    .then((notification) => {

                        if (! notification || this.state.id !== notification.notificacion) {

                            router.navigate(Routes[5].url, {
                                historyAPIMethod: 'replaceState'
                            })

                            return
                        }

                        this.state.notification = notification

                        this.instances.lightbox.complaints = GLightbox({
                            touchNavigation: true,
                            dragToleranceY: 0,
                            elements: [{
                                href: `https://notificaciones.sys-dev.com.mx/proxy/?csurl=https://moviljal.cfe.mx/suterm/image.php/${btoa(notification.archivo)}`,
                                type: 'image',
                                title: `Notificación ${notification.notificacion}`,
                                description: renderString('Fecha {{ fecha | datetime }}', notification)
                            }]
                        })

                        this.instances.lightbox.evidences = GLightbox({
                            touchNavigation: true,
                            dragToleranceY: 0,
                            elements: []
                        })

                        setHtml(this.visitDetails(), render('visit-details.html', notification))
                    })
                    .catch(() => {})
            })
            .catch(() => {

                sendEvent(Events.SHOW_LOGIN, { message: '' })
            })
    }

    showComplaints = () => {

        this.instances.lightbox.complaints.open()
    }

    showEvidences = () => {

        this.instances.lightbox.evidences.open()
    }
}
